module.exports = __webpack_public_path__ + "img/立即兌換.8387508d.png";